module.exports = __webpack_public_path__ + "img/certificate-2.d6991117.png";